<div class="card">
  <div class="card-header flex-between">
    <h5>Business Rules Configuration</h5>
    <div class="flex-start gap-2">
      <button class="btn btn-primary-soft" (click)="addNewRange(true)">
        Add New Range
      </button>
      <button class="btn btn-primary-soft" (click)="addNewLabel()">
        Add New Column
      </button>
      <button
        class="btn btn-primary-soft"
        (click)="saveChanges()"
        [disabled]="loading.save"
      >
        Save Changes
      </button>
      <button class="btn btn-primary-soft" (click)="loadBusinessRules()">
        Refresh
      </button>
    </div>
  </div>

  <div class="card-body">
    <!-- Add main loader -->
    <div class="loader-container" *ngIf="loading.main">
      <div class="spinner-border text-primary"></div>
    </div>

    <!-- Main content -->
    <div [class.content-loading]="loading.main">
      <!-- Race Type Tabs -->
      <div class="nav-tabs flex-start mb-3">
        <div
          class="tab uppercase-pointer"
          *ngFor="let type of types"
          [class.active]="currentType === type"
          (click)="selectType(type)"
        >
          {{ type }}
        </div>
      </div>

      <!-- Harness Segment Type Tabs -->
      <div class="nav-tabs flex-start mb-3" *ngIf="currentType === 'harness'">
        <div
          class="tab uppercase-pointer"
          [class.active]="currentSegmentType === 'standard'"
          (click)="selectSegmentType('standard')"
        >
          Standard Segments
        </div>
        <div
          class="tab uppercase-pointer"
          [class.active]="currentSegmentType === 'non-standard'"
          (click)="selectSegmentType('non-standard')"
        >
          Non-Standard Segments
        </div>
      </div>

      <!-- Configuration Settings -->
      <div class="table-container mb-4" *ngIf="currentType === 'harness' && currentSegmentType === 'non-standard'">
        <div class="table-header">
          Non-Standard Segment Configuration
        </div>
        <div class="form-section-body">
          <div class="grid-container m-0">
            <div class="form-group m-0">
              <label>Minimum Segment Length (m)</label>
              <input
                type="number"
                class="form-control"
                [(ngModel)]="minSegmentLength"
                (change)="editedCells['minSegmentLength'] = true"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- Average Speed Table -->
      <div class="table-container">
        <div class="table-header">
          {{ currentType | titlecase }} {{ currentSegmentType | titlecase }} Average Speed Min and Max
        </div>
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th style="min-width: 180px;">Segment <i class="fa fa-long-arrow-right" aria-hidden="true"></i></th>
                <ng-container *ngFor="let segment of segments; let i = index">
                  <th colspan="2" style="min-width: 200px;">
                    <div class="label-container">
                      <span>{{ segment }}</span>
                    </div>
                  </th>
                </ng-container>
              </tr>
              <tr>
                <th style="min-width: 180px;">Label <i class="fa fa-long-arrow-right" aria-hidden="true"></i></th>
                <ng-container *ngFor="let label of getCurrentLabels(); let i = index">
                  <th class="editable" colspan="2" style="min-width: 200px;">
                    <div class="label-container">
                      <input
                        type="text"
                        [value]="label"
                        (change)="onLabelEdit($event, i)"
                      />
                      <button
                        class="btn-remove-label"
                        title="Remove column"
                        (click)="removeLabel(i)">
                        <i class="bi bi-x"></i>
                      </button>
                    </div>
                  </th>
                </ng-container>
                <th style="min-width: 80px;">Actions</th>
              </tr>
              <tr>
                <th style="min-width: 180px;">Range in Meters</th>
                <ng-container *ngFor="let label of getCurrentLabels()">
                  <th style="min-width: 100px;">Min (km/h)</th>
                  <th style="min-width: 100px;">Max (km/h)</th>
                </ng-container>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let range of getCurrentRanges(); let rangeIndex = index">
                <td class="editable">
                  <div class="range-inputs">
                    <input
                      type="number"
                      [value]="range.min"
                      (change)="onRangeEdit($event, rangeIndex, 'min', true)"
                      step="1"
                    />
                    <span>-</span>
                    <input
                      type="number"
                      [value]="range.max === null ? '' : range.max"
                      (change)="onRangeEdit($event, rangeIndex, 'max', true)"
                      step="1"
                      placeholder="No Limit"
                    />
                  </div>
                </td>
                <ng-container *ngFor="let label of getCurrentLabels(); let labelIndex = index">
                  <td
                    class="editable"
                    [class.edited]="isEdited('speed_' + rangeIndex + '_' + labelIndex + '_true')"
                  >
                    <input
                      type="number"
                      [value]="getSpeedValue(rangeIndex, labelIndex, true)"
                      (change)="onSpeedEdit($event, rangeIndex, labelIndex, true)"
                      step="0.01"
                    />
                  </td>
                  <td
                    class="editable"
                    [class.edited]="isEdited('speed_' + rangeIndex + '_' + labelIndex + '_false')"
                  >
                    <input
                      type="number"
                      [value]="getSpeedValue(rangeIndex, labelIndex, false)"
                      (change)="onSpeedEdit($event, rangeIndex, labelIndex, false)"
                      step="0.01"
                    />
                  </td>
                </ng-container>
                <td class="actions">
                  <button class="btn btn-danger-soft" (click)="removeRange(rangeIndex, true)">
                    <i class="bi bi-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Stride Length Table -->
      <div class="table-container mt-4">
        <div class="table-header">
          {{ currentType | titlecase }} Stride Length, Frequency & Top Speed
        </div>
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th style="min-width: 180px;">Range in Meters</th>
                <th style="min-width: 120px;">Min Length</th>
                <th style="min-width: 120px;">Max Length</th>
                <th style="min-width: 120px;">Min Frequency</th>
                <th style="min-width: 120px;">Max Frequency</th>
                <th style="min-width: 150px;">Top Speed Min (km/h)</th>
                <th style="min-width: 150px;">Top Speed Max (km/h)</th>
                <th style="min-width: 80px;">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let range of getOtherMetricsRanges(); let rangeIndex = index">
                <td class="editable">
                  <div class="range-inputs">
                    <input
                      type="number"
                      [value]="range.min"
                      (change)="onRangeEdit($event, rangeIndex, 'min', false)"
                      step="1"
                    />
                    <span>-</span>
                    <input
                      type="number"
                      [value]="range.max === null ? '' : range.max"
                      (change)="onRangeEdit($event, rangeIndex, 'max', false)"
                      step="1"
                      placeholder="No Limit"
                    />
                  </div>
                </td>
                <td
                  class="editable"
                  [class.edited]="
                    isEdited('stride_length_' + rangeIndex + '_true')
                  "
                >
                  <input
                    type="number"
                    [value]="getMetricValue(rangeIndex, 'stride_length', true)"
                    (change)="
                      onMetricEdit($event, rangeIndex, 'stride_length', true)
                    "
                    step="0.01"
                  />
                </td>
                <td
                  class="editable"
                  [class.edited]="
                    isEdited('stride_length_' + rangeIndex + '_false')
                  "
                >
                  <input
                    type="number"
                    [value]="getMetricValue(rangeIndex, 'stride_length', false)"
                    (change)="
                      onMetricEdit($event, rangeIndex, 'stride_length', false)
                    "
                    step="0.01"
                  />
                </td>
                <td
                  class="editable"
                  [class.edited]="
                    isEdited('stride_frequency_' + rangeIndex + '_true')
                  "
                >
                  <input
                    type="number"
                    [value]="
                      getMetricValue(rangeIndex, 'stride_frequency', true)
                    "
                    (change)="
                      onMetricEdit($event, rangeIndex, 'stride_frequency', true)
                    "
                    step="0.01"
                  />
                </td>
                <td
                  class="editable"
                  [class.edited]="
                    isEdited('stride_frequency_' + rangeIndex + '_false')
                  "
                >
                  <input
                    type="number"
                    [value]="
                      getMetricValue(rangeIndex, 'stride_frequency', false)
                    "
                    (change)="
                      onMetricEdit(
                        $event,
                        rangeIndex,
                        'stride_frequency',
                        false
                      )
                    "
                    step="0.01"
                  />
                </td>
                <td
                  class="editable"
                  [class.edited]="
                    isEdited('top_speed_method1_' + rangeIndex + '_true')
                  "
                >
                  <input
                    type="number"
                    [value]="
                      getMetricValue(rangeIndex, 'top_speed_method1', true)
                    "
                    (change)="
                      onMetricEdit(
                        $event,
                        rangeIndex,
                        'top_speed_method1',
                        true
                      )
                    "
                    step="0.01"
                  />
                </td>
                <td
                  class="editable"
                  [class.edited]="
                    isEdited('top_speed_method1_' + rangeIndex + '_false')
                  "
                >
                  <input
                    type="number"
                    [value]="
                      getMetricValue(rangeIndex, 'top_speed_method1', false)
                    "
                    (change)="
                      onMetricEdit(
                        $event,
                        rangeIndex,
                        'top_speed_method1',
                        false
                      )
                    "
                    step="0.01"
                  />
                </td>
                <td class="actions">
                  <button
                    class="btn btn-danger-soft"
                    (click)="removeRange(rangeIndex, false)"
                  >
                    <i class="bi bi-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
